module.exports = __webpack_public_path__ + "img/header1-logo.cf61d5f5.svg";